exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-footer{position:fixed;height:40px;width:100%;bottom:0;background-color:#fff;padding:0 20px;font-weight:400;color:#a9a9aa;font-size:14px;display:flex;flex-direction:row;align-items:center;z-index:2000;border-top:#e4e4e4 1px solid;box-sizing:border-box}.c-footer_copyright{display:inline-block}.c-footer_version{margin-left:20px;display:inline-block}.c-footer_help{flex:1 0 auto;text-align:right;display:inline-block}.c-footer_help_link{cursor:pointer}.c-footer_help svg{height:14px;width:14px}", ""]);

// exports
